import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DataService } from "./data.service";
import { Observable } from "rxjs";
import { ServiceFilter } from "../model/service-filter";
import { SpecialityFilter } from "../model/speciality-filter";
import { Service, ServiceEquipment } from "../model/service";

@Injectable()
export class ServiceService {
  constructor(private dataService: DataService) {}

  private readonly getServicesFilterEndPoint: string =
    "/service/getServicesFilter/";
  private readonly getSpecialitiesFilterEndPoint: string =
    "/service/getSpecialtiesFilter/";
  private readonly getServiceByMedicalAppointmentIdEndPoint: string =
    "/service/getServiceByMedicalAppointmentId/";
  private readonly getServiceByIdEndPoint: string = "/service/getServiceById/";

  async getServiceById(serviceId: number): Promise<ServiceEquipment> {
    const params = { id: serviceId };
    return await this.dataService
      .get<ServiceEquipment>(this.getServiceByIdEndPoint, params)
      .toPromise();
  }

  async getServiceByMedicalAppointmentId(
    medicalAppointmentId: number
  ): Promise<Service> {
    const params = { medicalAppointmentId: medicalAppointmentId };
    return await this.dataService
      .get<Service>(this.getServiceByMedicalAppointmentIdEndPoint, params)
      .toPromise();
  }

  async getServicesFilter(sectorId?: number): Promise<ServiceFilter[]> {
    const params = { sectorId: sectorId };
    return await this.dataService
      .get<ServiceFilter[]>(this.getServicesFilterEndPoint, params)
      .toPromise();
  }

  async getSpecialtiesFilter(
    onlyConsultation: boolean = false
  ): Promise<SpecialityFilter[]> {
    const params = { onlyConsultation: onlyConsultation };
    return await this.dataService
      .get<SpecialityFilter[]>(this.getSpecialitiesFilterEndPoint, params)
      .toPromise();
  }
}
